import React, { Component } from "react";
import axios from "../../axios";
import Alert from "react-s-alert";
import moment from "moment";
import DateTimeField from "react-bootstrap-datetimepicker";
import DatePicker from "react-datepicker/es";
import Select from "react-select";
import qs from 'qs';

const NewDate    = moment().format('YYYY-MM-DD')

class Forms extends Component {
	constructor(props) {
		super(props);

		this.state = {
			libur_id    : "",
            libur_mulai_moment: null,
            libur_selesai_moment: null,
            libur_mulai: "",
            libur_selesai: "",
            libur_tanggal: "",
            libur_tanggal_moment: "",
            libur_desc  : "",
            date        : "",
            dateNow     : NewDate,
			isButtonLoading: false,
			isLoading   : false,
            participants: "",
            kelasNew        : [],
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDatepickerStartChange = this.handleDatepickerStartChange.bind(this);
        this.handleDatepickerEndChange = this.handleDatepickerEndChange.bind(this);
        this.handleDatepickerChange = this.handleDatepickerChange.bind(this);
        this.handleChangeMultiSelect = this.handleChangeMultiSelect.bind(this);
	}

	handleChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
    }

    handleChangeMultiSelect(stateName, text) {
        this.setState({[stateName]: text});

        if (stateName == 'participants') {
            let kelas = [];
            for (var i = 0; i < text.length; i++) {
                kelas.push(text[i].value);
            }

            const kelasNew = kelas.join(',');

            this.setState({
                kelasNew
            });
        }

    }

    handleDatepickerChange(date) {
        if (date !== null) {
            this.setState({
                libur_tanggal_moment: date,
                libur_tanggal: date.format("YYYY-MM-DD")
            });
        } else {
            this.setState({ libur_tanggal: "" });
        }
    }

    handleDatepickerStartChange(date) {
        if (date !== null) {
            this.setState({
                libur_mulai_moment: date,
                libur_mulai: date.format("YYYY-MM-DD")
            });
        } else {
            this.setState({ libur_mulai: "" });
        }
    }

    handleDatepickerEndChange(date) {
        if (date !== null) {
            this.setState({
                libur_selesai_moment: date,
                libur_selesai: date.format("YYYY-MM-DD")
            });
        } else {
            this.setState({ libur_selesai: "" });
        }
    }

    handleSubmit() {
        let formData = new FormData();
        let libur_mulai=''
        let libur_selesai=''

        const config = {
			headers: { "content-type": "multipart/form-data" }
        };
        
        if(this.state.libur_mulai_moment == null){
            libur_mulai =''
        }else{
            libur_mulai = this.state.libur_mulai_moment
        }
        
        if(this.state.libur_selesai_moment == null){
            libur_selesai =''
        }else{
            libur_selesai = this.state.libur_selesai_moment
        }

		formData.append("libur_id", this.state.libur_id);
		if (this.props.mode === "Tambah"){

            formData.append("libur_mulai", libur_mulai);
            formData.append("libur_selesai", libur_selesai);
            formData.append("kelas_id", this.state.kelasNew);
        } else {
            formData.append("libur_tanggal", this.state.libur_tanggal);
        }
		formData.append("libur_desc", this.state.libur_desc);

		const url = this.props.mode === "Tambah" ? "libur/add" : "libur/edit";

		this.setState({ isButtonLoading: true });

		axios.post(url, formData, config)
			.then(response => {
                
				const result = response.data;

				if (result.success) {
					Alert.success(result.message);
					this.props.history.replace("/libur");
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
							Alert.error(item);

							return true;
						});
					} else {
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			}); 
	}

	loadData() {

		if (this.props.mode === "Edit") {
			this.setState({ isLoading: true });

			axios({
				method: "get",
                url: "/libur/" + this.props.match.params.libur_id
            })

            .then(response => {

                const result = response.data;
                
                if(result.success){

                    this.setState({
                        libur_id: result.data.libur_id,
                        libur_tanggal: result.data.libur_tanggal,
                        libur_tanggal_moment: moment(result.data.libur_tanggal),
                        libur_desc: result.data.libur_desc,
                    });

                }else{
                    Alert.error(result.message)
                }
               
                this.setState({ isLoading: false });
                console.log(response)
            })
            .catch(error => {
                console.log(error);
                Alert.error("Gagal terhubung ke server!");
                this.setState({ isLoading: false });
            });
		}
    }
    
    loadDataKelas() {
        this.setState({isLoadingDataKelas: true});

        const params = qs.stringify({
            locale: "id",
            platform: "web"
        })
        axios({
            method: 'post',
            url: '/kelas'
        })

            .then(response => {
                const result = response.data;
                if (result.success) {
                    const dataKelas = result.data.map(item => ({
                        value: item.kelas_id,
                        label: item.kelas_nama
                    }));

                    this.setState({
                        dataKelas,
                        isLoadingDataKelas: false
                    });
                } else {
                    if (Array.isArray(result.text)) {
                        result.text.map(item => {
                            Alert.error(item);

                            return true;
                        });
                    } else {
                        Alert.error(result.text);
                    }

                    this.setState({isLoadingDataKelas: false});
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({isLoadingDataKelas: false});
                Alert.error("Gagal terhubung ke server!");
            });
    }

	componentDidMount() {
		this.loadData();
        this.loadDataKelas()
	}

	render() {
		return (
			<div className="col-sm-12">
				<div className="card">
					<div className="card-header">{this.props.mode} Hari Libur</div>
					<div className="card-block">
						{this.state.isLoading ? (
							"Memuat Data..."
						) : (
							<div className="form-horizontal animated fadeIn">
								{
									this.props.mode === 'Tambah' ? (
										<div>
                                            <div className="form-group row">
                                                <label className="col-md-2 form-control-label">
                                                    Kelas yang mengikuti
                                                </label>
                                                <div className="col-md-10">
                                                    <Select
                                                        multi
                                                        value={this.state.participants}
                                                        onChange={text =>
                                                            this.handleChangeMultiSelect("participants", text)
                                                        }
                                                        options={this.state.dataKelas}
                                                        placeholder="Kelas yang mengikuti"
                                                        removeSelected={this.state.removeSelected}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-md-2 form-control-label">
                                                    Libur Mulai
                                                </label>
                                                <div className="col-md-4">

                                                    <DatePicker
                                                        selected={this.state.libur_mulai_moment}
                                                        selectsStart
                                                        startDate={this.state.libur_mulai_moment}
                                                        endDate={this.state.libur_selesai_moment}
                                                        onChange={this.handleDatepickerStartChange}
                                                        dateFormat="YYYY-MM-DD"
                                                        withPortal
                                                        minDate={new Date()}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-md-2 form-control-label">
                                                    Libur Selesai
                                                </label>
                                                <div className="col-md-4">

                                                    <DatePicker
                                                        selected={this.state.libur_selesai_moment}
                                                        selectsEnd
                                                        startDate={this.state.libur_mulai_moment}
                                                        endDate={this.state.libur_selesai_moment}
                                                        onChange={this.handleDatepickerEndChange}
                                                        dateFormat="YYYY-MM-DD"
                                                        withPortal
                                                        minDate={this.state.libur_mulai_moment}
                                                    />
                                                </div>
                                            </div>
										</div>
									):(
                                        <div>
                                            <div className="form-group row">
                                                <label className="col-md-2 form-control-label">
                                                    Libur Tanggal
                                                </label>
                                                <div className="col-md-4">

                                                    <DatePicker
                                                        selected={this.state.libur_tanggal_moment}
                                                        selectsStart
                                                        startDate={this.state.libur_tanggal_moment}
                                                        onChange={this.handleDatepickerChange}
                                                        dateFormat="YYYY-MM-DD"
                                                        withPortal
                                                    />
                                                </div>
                                            </div>
                                        </div>
									)
								}

								<div className="form-group row">
									<label className="col-md-2 form-control-label">
										Keterangan Libur
									</label>
									<div className="col-md-8">
										<input
											name="libur_desc"
											type="text"
											className="form-control"
											placeholder="Keterangan Libur"
											onChange={this.handleChange}
											value={this.state.libur_desc}
										/>
									</div>
								</div>
							</div>
						)}
					</div>
					<div className="card-footer">
						<button
							type="button"
							className="btn btn-md btn-primary"
							disabled={this.state.isButtonLoading && "disabled"}
							onClick={this.handleSubmit}
						>
							{this.state.isButtonLoading ? "Loading" : "Simpan"}
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default Forms;



// WEBPACK FOOTER //
// ./src/views/Libur/Forms.js